import React, { Component } from 'react'
import {
  Col,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Form,
  FormGroup,
  Label,
  Input
} from 'reactstrap';
import AdminOrdersTable from './AdminOrdersTable';

export default class AdminEvents extends Component {

  state = {
    events: [],
    path: '',
    modal: false,
    active: {}
  }

  toggle = () => {
    this.setState({modal: !this.state.modal})
  }

  postNewEvent = (e) => {
    e.preventDefault();
    alert("Demo mode: event not actually created.");
    this.toggle();
  }

  loadTable = (path) => {
    this.setState({path: path})
  }

  render() {

    const EventCard = ({event: { name, date, numOfOrders, active, path }}) => {
      return (
        <div className="event-card event-card-container" onClick={() => this.loadTable(path)}>
            <div className="unit-card-content">
              <div className="event-card-name">{name}</div>
              <div className="event-card-date">{date}</div>
              <div className="event-card-order-amnt">{`Number of orders: ${numOfOrders}`}</div>
              <div className="event-card-active">{active}</div>
            </div>
        </div>
      )
    }

    return (
      <div>
        <h1>Di hevent dem</h1>
        <span>Active event: {this.state.active && this.state.active.name}</span>
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
          <Form onSubmit={this.postNewEvent}>
            <ModalHeader toggle={this.toggle}>New Event</ModalHeader>
            <ModalBody>
                <FormGroup row>
                <Label for="name" sm={2}>Name</Label>
                  <Col sm={10}>
                    <Input type="text" name="name" id="name" placeholder="Event name" />
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Label for="date" sm={2}>Date</Label>
                  <Col sm={10}>
                    <Input type="date" name="date" id="date" placeholder="mm/dd/yyyy" />
                  </Col>
              </FormGroup>
              <FormGroup row>
                  <Label for="path" sm={2}>Path</Label>
                  <Col sm={10}>
                    <Input type="text" name="path" id="path" placeholder="/event" />
                  </Col>
              </FormGroup>
            </ModalBody>
            <ModalFooter>
              <Button type="submit" color="primary">Create Event</Button>{' '}
              <Button color="secondary" onClick={this.toggle}>Cancel</Button>
            </ModalFooter>
          </Form>
        </Modal>

        <Col md={12} xs={12}></Col>
          <div onClick={this.toggle} className="event-card event-card-container" >
              <div className="unit-card-content">
                add event
              </div>
          </div>
          {this.state.events[0] && this.state.events.map(e => <EventCard event={e} key={e._id}/>)}
          {this.state.path && <AdminOrdersTable path={this.state.path} />}
        <Col/>
      </div>
    )
  }
}
